import { SubscriptionTier } from './subscriptionTiers';

export interface PlanFeature {
  feature: string;
  description?: string;
  highlight?: boolean;
}

export interface SubscriptionPlan {
  tier: SubscriptionTier;
  name: string;
  price: {
    monthly: number;
    annual: number;
  };
  features: PlanFeature[];
  annualSavings?: string;
}

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    tier: 'FREE',
    name: 'Free',
    price: {
      monthly: 0,
      annual: 0
    },
    features: [
      { feature: 'SMS Reciprocal Contact sharing' },
      { feature: '20 Speech to Contacts conversions per month' },
      { feature: 'Phone & email contact information' }
    ]
  },
  {
    tier: 'PRO',
    name: 'Pro',
    price: {
      monthly: 4.95,
      annual: 49.50
    },
    features: [
      { feature: 'Enhanced Speech Analysis', highlight: true, description: 'Better accuracy, Accents, Background noise filtering, Advanced speech recognition capabilities' },
      { feature: '50 Speech to Contacts conversions per month' },
      { feature: 'Up to 5 different profile collections of contact details' },
      { feature: 'Share Social Media, Websites & Address information' }
    ],
    annualSavings: 'Save 2 months with annual plan'
  },
  {
    tier: 'BUSINESS_PRO',
    name: 'Business Pro',
    price: {
      monthly: 9.95,
      annual: 99.50
    },
    features: [
      { feature: 'Everything in Pro, plus:', highlight: true },
      { feature: '150 Speech to Contacts conversions per month' },
      { feature: 'Up to 20 different profile collections of contact details' },
      { feature: 'Professional networks integration', description: 'LinkedIn, GitHub, Skype, WhatsApp & more' },
      { feature: 'Google Drive, Dropbox & Flickr gallery sharing', description: 'Share files via Google Drive, Dropbox, Flickr image & video gallery' }
    ],
    annualSavings: 'Save 2 months with annual plan'
  }
];
